import TenderFormView from "@/pages/createTender/components/tender-form-view";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Box, Container, Typography, Paper } from "@mui/material";
import { FileText } from "lucide-react";

export default function TenderPage() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        py: 4,
      }}
    >
      <Container maxWidth="xl">
        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            background: "white",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
              borderBottom: "1px solid #e5e7eb",
              p: 4,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <Box
                sx={{
                  width: 4,
                  height: 32,
                  background:
                    "linear-gradient(135deg, #644980 0%, #1d4ed8 100%)",
                  borderRadius: 2,
                }}
              />
              <Typography
                sx={{
                  fontSize: { md: "2rem", xs: "1.5rem" },
                  fontWeight: 700,
                  background:
                    "linear-gradient(135deg, #1f2937 0%, #374151 100%)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {t("general.purchaseRequest")}
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                color: "#6b7280",
                fontSize: "1.1rem",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <FileText size={20} />
              {t("general.FillFormToRequestPurchase")}
            </Typography>
          </Box>

          {/* Form Content */}
          <Box sx={{ p: 0 }}>
            <TenderFormView />
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
